<template>
	<div>
		<v-tooltip v-if="!isLoading" top>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					class="btn-round"
					fixed
					style="right: 5px"
					v-on="on"
					v-bind="attrs"
					color="purple"
					bottom
					right
					fab
					x-large
					depressed
					@click="isDateDialogOpen = true"
				>
					<v-icon color="white">mdi-calendar</v-icon>
				</v-btn>
			</template>
			<span>Filtrar por Fecha</span>
		</v-tooltip>

		<v-tooltip top v-if="!hidden">
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					class="btn-round"
					fixed
					style="right: 85px"
					v-on="on"
					v-bind="attrs"
					color="deep-purple"
					bottom
					right
					fab
					x-large
					depressed
					@click="filters = []"
				>
					<v-hover open-delay="200" v-slot="{ hover }">
						<v-icon v-if="!hover" color="white"
							>mdi-numeric-{{ filters.length }}-circle</v-icon
						>
						<v-icon v-else color="white">mdi-delete</v-icon>
					</v-hover>
				</v-btn>
			</template>
			<span>Número de Filtros</span>
		</v-tooltip>

		<v-btn-toggle
			class="no-background my-1"
			multiple
			v-model="filters"
			v-if="!hidden"
		>
			<v-tooltip v-for="(item, index) in statesIds" top>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						class="btn-round"
						:style="`right: ${index * 80 + 85}px;`"
						fixed
						v-on="on"
						v-bind="attrs"
						bottom
						right
						fab
						x-large
						depressed
						:key="index"
						:color="isSelected(index) ? item.color : 'white'"
					>
						<v-icon
							:color="isSelected(index) ? 'white' : 'black'"
							>{{ item.icon }}</v-icon
						>
					</v-btn>
				</template>
				<span>{{ item.text }}</span>
			</v-tooltip>
		</v-btn-toggle>

		<v-card style="height: 100vh" v-if="isLoading">
			<LoadingSkeleton />
		</v-card>
		<div v-else>
			<v-tabs v-model="tab" fixed-tabs center-active touchless>
				<v-tab
					v-for="item in items"
					:key="item.tab"
					class="primary--text"
				>
					{{ item.tab }}
					<v-icon color="primary">{{ item.icon }}</v-icon>
				</v-tab>
			</v-tabs>
			<v-tabs-items v-model="tab">
				<v-tab-item v-for="item in items" :key="item.tab">
					<component :is="item.component" />
				</v-tab-item>
			</v-tabs-items>
		</div>

		<v-dialog width="auto" v-model="isDateDialogOpen" persistent>
			<v-card>
				<v-card-title>
					<h2 class="font-weight-light">Filtrar por Fecha</h2>
				</v-card-title>
				<v-divider class="mx-4 mb-8"></v-divider>
				<v-card-text>
					<v-date-picker v-model="date" range></v-date-picker>
				</v-card-text>
				<v-card-actions>
					<v-btn
						:disabled="isLoading"
						depressed
						color="primary"
						@click="
							isDateDialogOpen = false;
							date = [];
							filterBydate();
						"
						>Reset</v-btn
					>
					<v-spacer></v-spacer>
					<v-btn
						:disabled="isLoading"
						color="success"
						depressed
						@click="
							isDateDialogOpen = false;
							filterBydate();
						"
						>Aceptar</v-btn
					>
					<v-btn color="red" text @click="isDateDialogOpen = false"
						>Cerrar</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import seguimientoOfertasDetalle from './seguimientoOfertasDetalle.vue';
import seguimientoOfertasResumen from './seguimientoOfertasResumen.vue';
import seguimientoOfertasOfertas from './seguimientoOfertasOfertas.vue';
import seguimientoOfertasSecond from './seguimientoOfertasSecond.vue';
import tramitacionesOfertas from './tramitacionesOfertas.vue';
import retailXdashBoard from './retailXdashBoard.vue';
import tickets from './tickets.vue';

import LoadingSkeleton from '@/components/ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';
import Dial from './Dial.vue';
import { mapState } from 'vuex';
import statesIds from '@/util/retailX/offerStates.js';

export default {
	name: 'RetailX',
	components: {
		tickets,
		seguimientoOfertasDetalle,
		seguimientoOfertasResumen,
		seguimientoOfertasOfertas,
		seguimientoOfertasSecond,
		tramitacionesOfertas,
		retailXdashBoard,

		LoadingSkeleton,
		Dial,
	},
	data: () => ({
		statesIds,
		tab: 0,
		date: [],
		noFilterTabs: [0, 2, 3, 4, 6],
		isDateDialogOpen: false,
		items: [
			{
				tab: 'Dashboard',
				icon: 'mdi-view-dashboard',
				component: 'retailXdashBoard',
			},
			{
				tab: 'Detalle',
				icon: 'mdi-clipboard-search',
				component: 'seguimientoOfertasDetalle',
			},
			{
				tab: 'Resumen',
				icon: 'mdi-printer-pos-outline',
				component: 'seguimientoOfertasResumen',
			},
			{
				tab: 'Tramitaciones',
				icon: 'mdi-transcribe-close',
				component: 'tramitacionesOfertas',
			},
			{
				tab: 'Ofertas',
				icon: 'mdi-tag',
				component: 'seguimientoOfertasOfertas',
			},
			{
				tab: 'Second',
				icon: 'mdi-podium-silver',
				component: 'seguimientoOfertasSecond',
			},
			{
				tab: 'Tickets',
				icon: 'mdi-ticket',
				component: 'tickets',
			},
		],
	}),
	methods: {
		filterBydate() {
			let value = this.date;

			if (value[0] > value[1]) {
				value = [value[1], value[0]];
			}

			let dateObj = {
				since: value[0],
				until: value.length > 1 ? value[1] : null,
			};

			this.$store.commit('retailX/dateFilter', dateObj);
			this.$store.dispatch('retailX/fetchAll');
		},
		isSelected(index) {
			return this.filters.some((it) => it == index - 1);
		},
	},
	computed: {
		filters: {
			get() {
				return this.$store.state.retailX.filters;
			},
			set(value) {
				this.$store.commit('retailX/filters', value);
			},
		},
		hidden() {
			return this.noFilterTabs.some((item) => item === this.tab);
		},
		...mapState('retailX', {
			isLoading: (state) => state.isLoading,
		}),
	},
	beforeMount() {
		this.$store.dispatch('retailX/fetchAll');
	},
};
</script>

<style>
.btn-round {
	border-radius: 50px !important;
}
.no-background {
	background: none !important;
}

@media (max-width: 768px) {
	.btn-round {
		border-radius: 50% !important;
		height: 55px !important;
	}
}
</style>